module.exports = __webpack_public_path__ + "img/howtoapply_pc.7f0664cb.png";